import { iVersion } from '@/interface/version';
import request from '@/utils/request';
import requestUrl from '@/utils/requestUrl';
/* 创建版本号 */
export const postAddVersion = (data: iVersion): Promise<any> =>
  request({
    url: '/api/v1/omc/version/config',
    method: 'post',
    data,
  });
/* 修改创建版本号 */
export const updateVersion = (data: iVersion): Promise<any> =>
  request({
    url: '/api/v1/omc/version/config',
    method: 'put',
    data,
  });
/* 分页列表 */
export const getVersionList = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/version/config/page_list',
    params,
  });

/**
 * 设置当前版本
 * @param params
 */
export const setCurrentVersion = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/version/current`,
    method: 'put',
    data,
  });

/**
 * 校验版本号
 * @param params
 */
export const existsVersion = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/version/exists',
    method: 'put',
    data,
  });
/**
 * 校验版地址是否存在
 * @param params
 */
export const existsVersionUrl = (version: string): Promise<any> =>
  requestUrl({
    url: process.env.VUE_APP_ANDROID_BASE_API + version,
    method: 'head',
  });
